/**
 * Vedantrum — Delivery Option Card (Shiprocket)
 * assets/sr-delivery.js
 *
 * Navy premium design: truck icon circle, eyebrow label, title,
 * calendar/gift icon pills with checkmarks, Change button, trust footer.
 *
 * Remembers last checked pincode via localStorage (persists across page loads).
 */
(function () {
  'use strict';

  const CFG    = window.SR_CONFIG || {};
  const PROXY  = CFG.proxy_url || 'https://vedantrumwellness.com/api/check-delivery.php';
  const WEIGHT = CFG.weight || '0.5';
  const STORAGE_KEY = 'vd_delivery_pin';
/* ── Styles ──────────────────────────────────────────────── */
  const CSS = `
  div#vd-result {padding: 10px;}
    #sr-widget, #sr-widget *{box-sizing:border-box !important;margin:0;padding:0;font-family:inherit}
    #sr-widget{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif !important;margin:22px 0;display:block;width:100%}
    .vd-card{background:#fff;border:1px solid #eef0f4;border-radius:4px;overflow:hidden;box-shadow:0 4px 24px rgba(20,30,60,0.06);width:100%}
.vd-entry {padding: 10px !important;}
button#vd-go-btn {width: 88px;}
.vd-entry-title {margin-bottom: 10px !important;}
    .vd-main{display:flex;align-items:center;gap:26px;padding:32px 36px}
    .vd-truck-circle{flex-shrink:0;width:84px;height:84px;border-radius:50%;background:#f7f7f7;display:flex;align-items:center;justify-content:center}
    .vd-divider{flex-shrink:0;width:1px;align-self:stretch;background:#e3e6ee;min-height:90px}
    .vd-content{flex:1;min-width:0;padding-left:4px}
    .vd-eyebrow{font-size:11.5px;font-weight:700;letter-spacing:1.6px;color:#black;margin-bottom:8px;line-height:1}
    .vd-title{font-size:15px;font-weight:600;color:black;margin-bottom:20px;letter-spacing:-.2px;line-height:1.65}
    .vd-title-pin{color:black}
    .vd-rows{display:flex;flex-direction:column;gap:12px}
    .vd-row{display:flex;align-items:center;gap:14px}
    .vd-check-circle{flex-shrink:0;width:26px;height:26px;border-radius:50%;background:#f7f7f7;display:flex;align-items:center;justify-content:center}
    .vd-pill{flex: 1;
    display: flex;
    align-items: center;
    gap: 14px;
    background: #f7f7f7;
    border-radius: 1px;
    /* font-size: 4px !important; */
    padding: 5px 12px !important;
    min-height: 36px;}
    .vd-footer {
    margin-top: 10px !important;
}
    .vd-icon-box{flex-shrink:0;width:24px;height:24px;display:flex;align-items:center;justify-content:center;position:relative;color:#142a64}
    .vd-pill-divider{flex-shrink:0;width:1px;height:24px;background:#f7f7f7;margin:0 2px}
    .vd-pill-text{font-size:12px;color:#1c2333;line-height:1.4}
    .vd-pill-text b{color:#060606;font-weight:700}
    .vd-free-tag{position:absolute;bottom:-7px;left:50%;transform:translateX(-50%);background:#142a64;color:#fff;font-size:7px;font-weight:800;letter-spacing:.3px;padding:2px 5px;border-radius:3px;white-space:nowrap;line-height:1}
    .vd-change{flex-shrink:0;display:flex;align-items:center;gap:5px;height:46px;padding:0 24px;background:#fff;color:#060606;border:1.5px solid #060606;border-radius:23px;font-size:15px;font-weight:500;    padding: 11px !important;cursor:pointer;transition:background .15s;margin-left:8px}
    .vd-change:hover{background:#f1f3f9}

    .vd-footer{background:#f7f7f7;padding:18px 36px;display:flex;align-items:center;gap:14px;flex-wrap:wrap;border-top:1px solid #f7f7f7}
    .vd-footer-icon{flex-shrink:0;color:#142a64}
    .vd-footer-strong{font-size:13.5px;font-weight:700;color:#060606;white-space:nowrap}
    .vd-footer-divider{width:1px;height:16px;background:#cbd1e0;flex-shrink:0}
    .vd-footer-text{font-size:13px;color:#5b6378}

    .vd-entry{padding:30px 36px}
    .vd-entry-title{font-size:16px;font-weight:700;color:#0e0e0e;margin-bottom:16px;line-height:1.3}
    .vd-entry-row{display:flex;gap:10px;max-width:460px}
    .vd-pin-input{flex:1;height:48px;border:1.5px solid #dde1ec;border-radius:10px;padding:0 18px !Important;font-size:15px;font-weight:600;letter-spacing:1.3px;outline:none;color:#0f1b3d;background:#fff;transition:border-color .15s;min-width:0}
    .vd-pin-input:focus{border-color:#142a64}
    .vd-pin-input::placeholder{font-weight:400;letter-spacing:.4px;color:#aab0c2}
    .vd-go-btn{height:48px;padding:0 26px;background:#000000;color:#fff;border:none;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer;display:flex;align-items:center;gap:8px;justify-content:center;transition:opacity .15s;flex-shrink:0}
    .vd-go-btn:hover{opacity:.88}
    .vd-go-btn:disabled{opacity:.4;cursor:not-allowed}
    .vd-spin{width:13px;height:13px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:vd-spin .6s linear infinite;display:none}
    .vd-spin.on{display:block}
    @keyframes vd-spin{to{transform:rotate(360deg)}}
    .vd-err{display:flex;align-items:center;gap:7px;font-size:12.5px;color:#c0392b;margin-top:11px}
    .vd-hidden{display:none !important}

    @media(max-width:600px){
    input#vd-pin-input {padding: 10px;}
      .vd-main{flex-direction:column;align-items:flex-start;gap:18px;padding:24px 22px}
      .vd-truck-circle{width:60px;height:60px;display:none}
      .vd-divider{display:none}
      .vd-content{padding-left:0;width:100%}
      .vd-title{font-size:20px}
      .vd-change{width:100%;justify-content:center;margin-left:0;margin-top:6px}
      .vd-footer{padding:16px 22px; display:none}
      .vd-footer-text{width:100%}
      .vd-entry{padding:24px 22px}
      .vd-entry-row{max-width:none;flex-direction:row}
      .vd-go-btn{height:46px}
      .vd-pill{padding:12px 14px}
    }
  `;

  const TRUCK_SVG = `<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#060606" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9h2"/><path d="M2 12h3"/><path d="M5 9h7v8H5z"/><path d="M12 12h3l3 3v2h-6z"/><circle cx="8" cy="19" r="1.6"/><circle cx="17" cy="19" r="1.6"/></svg>`;
  const CHECK_SVG = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#060606" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>`;
  const CALENDAR_SVG = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#060606" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="17" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="7" y1="13" x2="9" y2="13"/><line x1="11" y1="13" x2="13" y2="13"/><line x1="15" y1="13" x2="17" y2="13"/><line x1="7" y1="17" x2="9" y2="17"/><line x1="11" y1="17" x2="13" y2="17"/></svg>`;
  const GIFT_SVG = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#060606" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7C12 7 9.5 2 7 2S4 4 4 5.5 5.5 7 7 7h5z"/><path d="M12 7c0 0 2.5-5 5-5s3 2 3 3.5S18.5 7 17 7h-5z"/></svg>`;
  const ARROW_SVG = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>`;
  const SHIELD_SVG = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#060606" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3z"/><path d="m9 12 2 2 4-4"/></svg>`;
  const ALERT_SVG = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>`;

  const HTML = `
    <div class="vd-card" id="vd-card">

      <div id="vd-entry">
        <div class="vd-entry">
          <div class="vd-entry-title">Check delivery for your area</div>
          <div class="vd-entry-row">
            <input class="vd-pin-input" id="vd-pin-input" type="tel" inputmode="numeric" maxlength="6" placeholder="Enter pincode" autocomplete="postal-code" />
            <button class="vd-go-btn" id="vd-go-btn">
              <span id="vd-go-text">Check</span>
              <div class="vd-spin" id="vd-spin"></div>
            </button>
          </div>
          <div class="vd-err vd-hidden" id="vd-err">${ALERT_SVG}<span id="vd-err-msg"></span></div>
        </div>
      </div>

      <div id="vd-result" class="vd-hidden">
        <div class="vd-main">
          <div class="vd-truck-circle">${TRUCK_SVG}</div>
          <div class="vd-divider"></div>
          <div class="vd-content">
            <div class="vd-eyebrow">DELIVERY OPTION</div>
            <div class="vd-title">Delivery option for <span class="vd-title-pin" id="vd-pin-display"></span></div>
            <div class="vd-rows">
              <div class="vd-row">
                <div class="vd-check-circle">${CHECK_SVG}</div>
                <div class="vd-pill">
                  <div class="vd-icon-box">${CALENDAR_SVG}</div>
                  <div class="vd-pill-divider"></div>
                  <div class="vd-pill-text" id="vd-delivery-text"></div>
                </div>
              </div>
              <div class="vd-row">
                <div class="vd-check-circle">${CHECK_SVG}</div>
                <div class="vd-pill">
                  <div class="vd-icon-box">${GIFT_SVG}<span class="vd-free-tag">FREE</span></div>
                  <div class="vd-pill-divider"></div>
                  <div class="vd-pill-text"><b>Free Delivery</b> on all prepaid orders</div>
                </div>
              </div>
            </div>
          </div>
          <button class="vd-change" id="vd-change-btn">Change ${ARROW_SVG}</button>
        </div>
        <div class="vd-footer">
          ${SHIELD_SVG}
          <span class="vd-footer-strong">Safe. Secure. Delivered.</span>
          <div class="vd-footer-divider"></div>
          <span class="vd-footer-text">We ensure your order reaches you safely and on time.</span>
        </div>
      </div>

    </div>
  `;

  /* ── API ──────────────────────────────────────────────────── */
  async function fetchDelivery(pin) {
    const url = `${PROXY}?pin=${pin}&weight=${WEIGHT}&cod=1`;
    const res = await fetch(url);
    const data = await res.json();

    console.log('[Vedantrum Delivery] pincode:', pin, 'response:', data);

    if (data.error) throw new Error(data.error);
    if (!data.serviceable) throw new Error('Delivery not available for this pincode');

    const opt = (data.options || [])[0];
    if (!opt) throw new Error('No courier data returned for this pincode');

    const minD = Number(opt.min_days);
    const maxD = Number(opt.max_days);

    if (!minD || isNaN(minD)) throw new Error('Invalid delivery estimate from API');

    return (!maxD || maxD === minD)
      ? `Delivery in <b>${minD}</b> day${minD > 1 ? 's' : ''}`
      : `Delivery in <b>${minD} to ${maxD}</b> days`;
  }

  /* ── State ────────────────────────────────────────────────── */
  function showResult(pin, html) {
    document.getElementById('vd-pin-display').textContent = pin;
    document.getElementById('vd-delivery-text').innerHTML = html;
    document.getElementById('vd-entry').classList.add('vd-hidden');
    document.getElementById('vd-result').classList.remove('vd-hidden');
  }

  function showEntry() {
    document.getElementById('vd-result').classList.add('vd-hidden');
    document.getElementById('vd-entry').classList.remove('vd-hidden');
    const input = document.getElementById('vd-pin-input');
    input.value = '';
    input.focus();
  }

  function showError(msg) {
    document.getElementById('vd-err-msg').textContent = msg;
    document.getElementById('vd-err').classList.remove('vd-hidden');
  }

  function clearError() {
    document.getElementById('vd-err').classList.add('vd-hidden');
  }

  async function handleCheck() {
    const pin = document.getElementById('vd-pin-input').value.trim();
    if (!/^\d{6}$/.test(pin)) {
      showError('Enter a valid 6-digit pincode');
      return;
    }
    clearError();

    const btn  = document.getElementById('vd-go-btn');
    const text = document.getElementById('vd-go-text');
    const spin = document.getElementById('vd-spin');
    btn.disabled = true;
    text.classList.add('vd-hidden');
    spin.classList.add('on');

    try {
      const html = await fetchDelivery(pin);
      localStorage.setItem(STORAGE_KEY, pin);
      showResult(pin, html);
    } catch (e) {
      showError(e.message || 'Something went wrong. Please try again.');
    } finally {
      btn.disabled = false;
      text.classList.remove('vd-hidden');
      spin.classList.remove('on');
    }
  }

  /* ── Mount ────────────────────────────────────────────────── */
  function mount() {
    const el = document.getElementById('sr-delivery-widget');
    if (!el) return;

    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    el.innerHTML = '<div id="sr-widget">' + HTML + '</div>';

    const input = document.getElementById('vd-pin-input');
    input.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '');
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') handleCheck();
    });

    document.getElementById('vd-go-btn').addEventListener('click', handleCheck);
    document.getElementById('vd-change-btn').addEventListener('click', showEntry);

    const savedPin = localStorage.getItem(STORAGE_KEY);
    if (savedPin && /^\d{6}$/.test(savedPin)) {
      fetchDelivery(savedPin)
        .then(html => showResult(savedPin, html))
        .catch(() => { /* fall back to entry */ });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();